import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import gridIcon from "../assets/product-icons/gridlock.png";
import spendnoteIcon from "../assets/product-icons/spendnote.png";
import scoraIcon from "../assets/product-icons/scora.png";
import novaIcon from "../assets/portfolio/coming-soon.png";
import toolsIcon from "../assets/portfolio/coming-soon.png";

const products = [
  {
    id: "spendnote",
    name: "SpendNote",
    desc: "A clean expense tracking app for fast entries, receipt storage, budgeting, better money habits and personal finance clarity.",
    icon: spendnoteIcon,
    status: "Published app",
    link: "/products/spendnote",
  },
  {
    id: "scora",
    name: "Scora",
    desc: "A document search and knowledge app for finding information inside PDFs, scans, files and notes without folder friction.",
    icon: scoraIcon,
    status: "Product system",
    link: "/products/scora",
  },
  {
    id: "gridlock",
    name: "Grid Lock",
    desc: "A retro puzzle game published by Code7s with a focused mobile first game loop.",
    icon: gridIcon,
    status: "Game",
    link: "/products/gridlock",
  },
  {
    id: "nova",
    name: "Project Nova",
    desc: "A productivity and product management concept for creators, operators and startup teams, currently shaped inside Code7s.",
    icon: novaIcon,
    status: "In studio",
    link: "/products/nova",
  },
  {
    id: "tools",
    name: "Code7s Studio Tools",
    desc: "A suite of studio tools for founders, freelancers, indie developers and product teams planning MVPs, prototypes and software workflows.",
    icon: toolsIcon,
    status: "Tool suite",
    link: "/products/tools",
  },
];

export default function Products() {
  const navigate = useNavigate();

  return (
    <main className="premium-page">
      <section className="premium-shell">
        <motion.div
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="page-hero-block"
        >
          <p className="eyebrow">Published by Code7s</p>
          <h1 className="hero-heading mt-5">
            Apps, tools, and experiments from the studio.
          </h1>
          <p className="hero-copy">
            Code7s is not only a product studio for client work. We also
            publish our own mobile apps, productivity tools, finance apps,
            document search products and game experiments, which keeps our
            design taste and engineering grounded in real launches.
          </p>
        </motion.div>

        <div className="mt-14 grid gap-5 md:grid-cols-2">
          {products.map((product, index) => (
            <motion.button
              key={product.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
              onClick={() => navigate(product.link)}
              className="premium-card group rounded-[26px] p-6 text-center"
            >
              <div className="flex flex-col items-center gap-5">
                <div className="flex h-20 w-20 shrink-0 items-center justify-center rounded-3xl bg-neutral-950/5">
                  <img src={product.icon} alt="" className="h-12 w-12 object-contain" />
                </div>
                <div className="text-center">
                  <span className="rounded-full border border-neutral-950/10 bg-white/70 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-neutral-500">
                    {product.status}
                  </span>
                  <h2 className="mt-5 text-3xl font-extrabold tracking-tight">{product.name}</h2>
                </div>
              </div>
              <p className="mx-auto mt-5 max-w-xl leading-7 text-neutral-600">{product.desc}</p>
              <span className="mt-8 inline-flex items-center gap-2 text-sm font-bold">
                Open product <FiArrowUpRight aria-hidden="true" />
              </span>
            </motion.button>
          ))}
        </div>
      </section>
    </main>
  );
}
